// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4122) return "static/chunks/4122-ebef9e0c5c573cd0.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 474 ? "fe69a73d" : chunkId) + "." + {"138":"821f35dc7c7daa6a","474":"f7425f3a0aea3fdf","3657":"846f032f81b24590","5654":"af30789174b423bc"}[chunkId] + ".js";
};